import React from 'react';
import oreganoBowl from '../../images/oregano.jpg';
import productJar from '../../images/packaging/product-jar.png';
import productBag from '../../images/packaging/product-bag.png';
import productSachet from '../../images/packaging/product-sachet.png';
import thymeBag from '../../images/packaging/thyme-bag.png';
import oreganoOil from '../../images/packaging/oregano_oil.png';
import chamomilePack from '../../images/packaging/chamomile-bag.png';
import mountainTeaBag from '../../images/packaging/mountain-tea.png';

const ProductsSection = ({ t }) => {
  const productCategories = [
    {
      className: 'products__category products__category--oregano',
      title: t.products.oregano.title,
      text: t.products.oregano.text,
      isNew: false,
      packaging: [
        {
          className: 'product-card',
          image: productJar,
          alt: t.products.oregano.packaging1.alt,
          title: t.products.oregano.packaging1.title,
          text: t.products.oregano.packaging1.text,
        },
        {
          className: 'product-card product-card--bag',
          image: productBag,
          alt: t.products.oregano.packaging2.alt,
          title: t.products.oregano.packaging2.title,
          text: t.products.oregano.packaging2.text,
        },
        {
          className: 'product-card',
          image: productSachet,
          alt: t.products.oregano.packaging3.alt,
          title: t.products.oregano.packaging3.title,
          text: t.products.oregano.packaging3.text,
        },
        {
          className: 'product-card',
          image: oreganoBowl,
          alt: t.products.oregano.packaging4.alt,
          title: t.products.oregano.packaging4.title,
          text: t.products.oregano.packaging4.text,
        },
        {
          className: 'product-card',
          image: oreganoOil,
          alt: t.products.oregano.packaging5.alt,
          title: t.products.oregano.packaging5.title,
          text: t.products.oregano.packaging5.text,
        },
      ],
    },
    {
      className: 'products__category products__category--thyme',
      title: t.products.herb1.title,
      text: t.products.herb1.text,
      isNew: true,
      newLabel: t.products.newLabel,
      packaging: [
        {
          className: 'product-card product-card--bag',
          image: thymeBag,
          alt: t.products.herb1.packaging2.alt,
          title: t.products.herb1.packaging2.title,
          text: t.products.herb1.packaging2.text,
        },
      ],
    },
    {
      className: 'products__category products__category--chamomile',
      title: t.products.herb2.title,
      text: t.products.herb2.text,
      isNew: true,
      newLabel: t.products.newLabel,
      packaging: [
        {
          className: 'product-card product-card--bag',
          image: chamomilePack,
          alt: t.products.herb2.packaging2.alt,
          title: t.products.herb2.packaging2.title,
          text: t.products.herb2.packaging2.text,
        },
      ],
    },
    {
      className: 'products__category products__category--mountain-tea',
      title: t.products.mountainTea.title,
      text: t.products.mountainTea.text,
      isNew: true,
      newLabel: t.products.newLabel,
      packaging: [
        {
          className: 'product-card product-card--bag product-card--mountain-tea',
          mediaClassName: 'product-card__media product-card__media--mountain-tea',
          imageClassName: 'product-card__image-tilt',
          image: mountainTeaBag,
          alt: t.products.mountainTea.packaging1.alt,
          title: t.products.mountainTea.packaging1.title,
          text: t.products.mountainTea.packaging1.text,
        },
      ],
    },
  ];

  return (
    <section className="products" id="products">
      <div className="products__header">
        <div className="products__logo" aria-hidden="true">
          <span />
        </div>
        <div>
          <h2>{t.products.title}</h2>
          <p>{t.products.body}</p>
        </div>
      </div>
      <div className="products__categories">
        {productCategories.map((category) => (
          <div key={category.title} className={category.className}>
            <div className="products__category-copy">
              {category.isNew ? (
                <span className="products__new-badge">{category.newLabel}</span>
              ) : null}
              <div className="products__category-heading">
                <h3>{category.title}</h3>
              </div>
              <p>{category.text}</p>
            </div>
            <div
              className={`products__row products__row--herbs${
                category.packaging.length === 1 ? ' products__row--single' : ''
              }`}
            >
              {category.packaging.map((card) => (
                <article key={card.title} className={card.className}>
                  {card.mediaClassName ? (
                    <div className={card.mediaClassName}>
                      <img
                        className={card.imageClassName}
                        src={card.image}
                        alt={card.alt}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  ) : (
                    <img src={card.image} alt={card.alt} loading="lazy" decoding="async" />
                  )}
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
      <p className="products__note">{t.products.note}</p>
    </section>
  );
};

export default ProductsSection;
